import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import {environment} from '../../../environments/environment';

@Injectable()
export class CardTextsService {
    private headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

    constructor(
        private http: Http
    ) {
    }

    //Fetch All Cardlist registered
    getCardTextsList(offset, searchText, card_id) {
        let body = 'offset=' + offset + '&searchText=' + searchText + '&card_id=' + card_id + ''
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL + '/cardtextslist';
            this.http.post(apiURL, body, {headers: this.headers})
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    //Fetch single card_image information
    getCardTextInfo(iCardTextId) {
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL + '/cardtextinfo/' + iCardTextId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    //Fetch single card_image information
    getCategories() {
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL + '/categories';
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    //Delete Card
    deleteCardTextCall(iCardTextId) {
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL + '/deletecardtext/' + iCardTextId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    createCardText(cardValue) {
        const promise = new Promise((resolve, reject) => {
            debugger
            var form = new FormData();
            for (let key in cardValue) {
                form.append(key, cardValue[key]);
            }
            // let body = 'card_id=' + cardValue.card_id + '&font_size=' + cardValue.font_size + '&x=' + cardValue.x + '&height=' + cardValue.height + '&y=' + cardValue.y + '&width=' + cardValue.width + '&text=' + encodeURIComponent(cardValue.text) + '&alignment=' + cardValue.alignment + '&character_spacing=' + cardValue.character_spacing + '&font=' + cardValue.font + '&text_color=' + cardValue.text_color + '&line_spacing=' + cardValue.line_spacing + '&number_of_line=' + cardValue.number_of_line;
            let apiURL = environment.BASE_URL + '/cardtexts/create';
            // body = encodeURI(body);
            this.http.post(apiURL, form)
                .toPromise()
                .then(
                    res => { // Success
                        // console.log(res.json());
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    updateCardText(cardValue) {
        const promise = new Promise((resolve, reject) => {
            debugger
            var form = new FormData();
            for (let key in cardValue) {
                form.append(key, cardValue[key]);
            }
            form.set('card_texts_id', cardValue.card_texts_id);
            /*let body = 'card_texts_id=' + cardValue.card_texts_id + '&font_size=' + cardValue.font_size + '&x=' + cardValue.x +
                '&height=' + cardValue.height + '' +
                '&y=' + cardValue.y + '&width=' + cardValue.width + '&text=' + encodeURIComponent(cardValue.text) +
                '&alignment=' + cardValue.alignment + '&character_spacing=' + cardValue.character_spacing + '&font=' + cardValue.font +
                '&text_color=' + cardValue.text_color + '&line_spacing=' + cardValue.line_spacing + '&number_of_line=' + cardValue.number_of_line;
            body = encodeURI(body);*/
            const apiURL = environment.BASE_URL + '/cardtexts/update';
            this.http.post(apiURL, form)
                .toPromise()
                .then(
                    res => { // Success
                        /*console.log(res.json());*/
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/card_textsmaster/services/card_texts.service.ts